module.exports = __webpack_public_path__ + "img/estimated-insurance-required-input.c1ea4057.png";